import { createFileRoute } from "@tanstack/react-router";
import { PortalProjectPage } from "@/features/portalprojects/PortalProjectPage";

/** Portal project page for one project. Sits under /portal, so it uses the portal shell (no app chrome). */
export const Route = createFileRoute("/portal/projects/$project")({
  component: PortalProjectRoute,
});

function PortalProjectRoute() {
  const { project } = Route.useParams();
  return <PortalProjectPage projectId={project} />;
}
